export class CloneUtility {
  public static deepClone<T>(obj: T): T {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    let clonedObj: unknown;

    if (Array.isArray(obj)) {
      clonedObj = [] as unknown[];
      for (let i = 0; i < obj.length; i++) {
        clonedObj[i] = this.deepClone(obj[i]);
      }
      return clonedObj as unknown as T;
    }

    if (obj instanceof Date) {
      clonedObj = new Date((obj as Date).getTime()) as unknown;
      return clonedObj as T;
    }

    if (obj instanceof RegExp) {
      clonedObj = new RegExp((obj as RegExp).source, (obj as RegExp).flags) as unknown;
      return clonedObj as T;
    }

    clonedObj = {} as unknown;
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        clonedObj[key] = this.deepClone(obj[key]);
      }
    }
    return clonedObj as T;
  }
}
